import React from 'react';
import {Form, Row} from 'react-bootstrap';
import styled from 'styled-components';

interface FormGroupProps {
    children: React.ReactNode;
    controlId?: string;
    style?: React.CSSProperties;
    asRow?: boolean;
    className?: string;
    horizontal?: boolean;
}

export const FormGroup = ({
    controlId,
    children,
    style,
    asRow = true,
    horizontal = true,
    className,
}: FormGroupProps) => {
    // I could not make FormControl as Row work at all.
    // this is a workaround to make it work.
    return (
        <Group
            className={className}
            controlId={controlId}
            style={style}
            $horizontal={horizontal}>
            {asRow ? <Row>{children}</Row> : children}
        </Group>
    );
};

const Group = styled(Form.Group)<{$horizontal: boolean}>`
    margin-bottom: 10px;
    gap: 15px 0;
    display: flex;

    padding: 0 0 0 10px;

    label {
        padding-left: 0;
    }

    > div > div:last-child {
        padding-right: 0;
    }

    > div {
        flex-grow: 1;
        width: 100%;
    }

    label {
        font-size: 0.85em;
        font-weight: bold;
        color: ${({theme}) => theme.colors.primary?.main};
        position: relative;

        > span {
            color: ${({theme}) => theme.colors.errorLabel?.main};
        }
    }

    input {
        color: #495057 !important;
    }

    ${({$horizontal}) => {
        if (!$horizontal) {
            return `

                > div {
                    display: initial; 
                }

                > div > div:last-child {
                    padding-left: 0;
                }
            `;
        }
    }}
`;
